import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { NavLink, withRouter } from "react-router-dom";

import "./ButtonGroup.scss";

// activeClassName: hacke for remove react error about unsupported propert for div
const Div = ({ children, activeClassName, exact, to, ...props }) => (
  <div {...props}>{children}</div>
);

const ButtonGroup = ({ items, selected, onClick, theme, nav, className }) => {
  const ItemComponent = nav ? NavLink : Div;

  return (
    <div className={classnames("button-group", theme, className)}>
      {items.map(item => (
        <ItemComponent
          activeClassName="selected"
          className={classnames("item", { selected: item.code == selected })}
          onClick={() => onClick && onClick(item.code)}
          key={item.key || item.code}
          to={item.code}
          exact={item.exact}
        >
          {item.title}{" "}
          {item.count && <span className="count">{item.count}</span>}
        </ItemComponent>
      ))}
    </div>
  );
};

ButtonGroup.propTypes = {
  items: PropTypes.array.isRequired,
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func
};

export default withRouter(ButtonGroup);
